// Коллекция display-примитивов проекта («внутренняя дизайн-система»).
// Выделена из мастера ШМ (TIRE_FITTING_WIZARD_PLAN.md §7.2): компоненты без
// Formik и без доменной логики, TS, стили ко-локированы (по одному SCSS),
// цвета — только токены _colors.scss. Спецификация для дизайнеров — docs/DESIGN_SPEC.md.

export { default as Note } from './Note';
export { default as CountBadge } from './CountBadge';
export { default as MetaTile } from './MetaTile';
export { default as EmptyState } from './EmptyState';
export { default as ChoiceCard } from './ChoiceCard';
export { default as ChoiceGrid } from './ChoiceGrid';
export { default as StepSection } from './StepSection';
export { default as QtyStepper } from './QtyStepper';
export { default as StickyActionBar } from './StickyActionBar';
export { default as ConfirmModal } from './ConfirmModal';
